// frontend/src/components/AgencyDriverStats.js
// This React component displays driver statistics for an agency by pulling counts and capacity from Redux, and renders them using the StatusCounters component.
import React from 'react';
import { useSelector } from 'react-redux';
import StatusCounters from './StatusCounters';
import { selectCountsGlobal, selectAllDrivers } from '../features/drivers/driverSlice';
import { selectLimitByAgency } from '../features/agencies/agenciesSlice';
import { selectAgencyIdForUser } from '../features/auth/authSlice';

export default function AgencyDriverStats() {
  const agencyId   = useSelector(selectAgencyIdForUser);
  const counts     = useSelector(selectCountsGlobal);   // ← count the current slice (already scoped)
  const driversLen = useSelector(selectAllDrivers).length;

  const rawCap = useSelector(state =>
    agencyId != null ? selectLimitByAgency(state, agencyId) : null
  );
  const activeCap = Number.isFinite(Number(rawCap)) ? Number(rawCap) : null;

  // Debug visibility
  console.log('[AgencyDriverStats] drivers in slice:', driversLen, 'counts:', counts, 'cap:', activeCap);

  if (!agencyId) {
    return (
      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <p className="text-sm text-gray-600">Loading agency…</p>
      </div>
    );
  }

  return (
    <StatusCounters
      title="Your Drivers"
      counts={counts}
      activeCap={activeCap}
    />
  );
}
